import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "tab-content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tab.value,
          class: _normalizeClass(['tab-btn', { active: $props.modelValue === tab.value }]),
          onClick: $event => (_ctx.$emit('update:modelValue', tab.value)),
          type: "button"
        }, _toDisplayString(tab.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", { active: $props.modelValue }, undefined, true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}